import { ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Geolocation extends ClickElement {
  auto: boolean = false;
  buttonText: string = '';

  constructor() {
    super();
    this.elementType = ElementType.geolocation;
  }
}
